import { type ReactNode, useState } from "react";
import { HseInstanceContext } from "./hseInstanceContext";

export function HseInstanceProvider({
    instanceId,
    productInstanceId,
    children,
}: {
    instanceId: number;
    productInstanceId: number;
    children: ReactNode;
}) {
    const [selectedInstanceId, setSelectedInstanceId] = useState(instanceId);

    return (
        <HseInstanceContext.Provider
            value={{
                instanceId: selectedInstanceId,
                productInstanceId,
                setInstanceId: setSelectedInstanceId,
            }}
        >
            {children}
        </HseInstanceContext.Provider>
    );
}
